import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Popover } from "components";
import { css } from "react-emotion";
import ProfilePopup from "./ProfilePopup";
import { user as userType } from "api/users/types";
import Cart from "./cart";
import { changeLanguageWorker } from "ducks/ui/actions";
import { Link } from "react-router-dom";

import i5 from "assets/images/i5.svg";
import i4 from "assets/images/i4.svg";
// import i6 from 'assets/images/i6.svg';
// import i7 from 'assets/images/i7.svg';

const propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  changeLanguage: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  user: userType.isRequired,
};

type handleChangeLanguageType = {
  value: "en" | "pl",
};

class Header extends React.Component {
  handleChangeLanguage = ({ value }: handleChangeLanguageType) => {
    this.props.changeLanguage(value);
  };

  render() {
    const { open, toggle, user, location, cart } = this.props;
    const cartEmpty = cart.ids.length === 0;
    const cartQuantity = cart.ids.length > 9 ? "9+" : cart.ids.length;

    return (
      <nav className={`nav-toppanel ${open ? "" : closedNav}`}>
        <div className="main-nav">
          <div className="nav-toppanel--left">
            <div className="nav-toppanel--slide-left-btn">
              <button className="panel-open" type="button" onClick={toggle} />
            </div>
            <div className="nav-toppanel--icons-wrapper">
              <div className="nav-toppanel--single-icon-wrapper">
                <Link to="/products">
                  <span className="icon-box">
                    <img src={i4} alt="" />
                  </span>
                </Link>
              </div>
              <div className="nav-toppanel--single-icon-wrapper">
                <Popover orientation="right" offsetTop={90} location={location} fixed={true}>
                  {{
                    btn: open => (
                      <div className="icon-box" onClick={open}>
                        <img src={i5} alt="" />
                        {!cartEmpty && (
                          <span className="nt-counter">
                            <span>{cartQuantity}</span>
                          </span>
                        )}
                      </div>
                    ),
                    window: <Cart />,
                  }}
                </Popover>
              </div>
            </div>

            {/* <div className="nav-toppanel--icons-wrapper">
              <div className="icon-box">
                <img src={i6} alt="" />
              </div>
              <div className="icon-box">
                <img src={i7} alt="" />
              </div>
            </div> */}

            <div id="top-panel-portal" />
          </div>
          <div className="nav-toppanel--right">
            <div className="nav-toppanel--user-profile">
              <Popover orientation="left" offsetTop={90} location={location} fixed={true}>
                {{
                  btn: open => (
                    <div className="avatar-outer--sm-box a-bg-25">
                      <div className="avatar-inner-sm-box" onClick={open}>
                        {user.initials}
                      </div>
                    </div>
                  ),
                  window: <ProfilePopup user={user} changeLanguage={this.handleChangeLanguage} />,
                }}
              </Popover>
            </div>
          </div>
        </div>
        <div id="subnav-portal" className={subnavPortal} />
      </nav>
    );
  }
}

Header.propTypes = propTypes;

const mapState = state => ({
  user: state.auth.user,
  cart: state.cart,
});

const mapDispatch = {
  changeLanguage: changeLanguageWorker,
};

export default withRouter(
  connect(
    mapState,
    mapDispatch
  )(Header)
);

const closedNav = css`
  margin-left: 0;
  width: calc(100% - 20px);
`;

const subnavPortal = css`
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/subcomponents/Header.jsx